import React from "react";

const IconOrder = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 18.849 16.164">
      <g
        id="collection_2_"
        dataname="collection (2)"
        transform="translate(-2 -3.5)"
        opacity="0.7"
      >
        <rect
          id="Rectangle_1057"
          dataname="Rectangle 1057"
          width="17.849"
          height="9.349"
          transform="translate(2.5 9.815)"
          fill="none"
          stroke="#000"
          strokeWidth="1"
        />
        <path
          id="Path_3733"
          dataname="Path 3733"
          d="M4,9.818V7H19.03V9.818"
          transform="translate(-0.091 -0.182)"
          fill="none"
          stroke="#000"
          strokeWidth="1"
        />
        <path
          id="Path_3734"
          dataname="Path 3734"
          d="M6,6.818V4H17.272V6.818"
          transform="translate(-0.212)"
          fill="none"
          stroke="#000"
          strokeWidth="1"
        />
      </g>
    </svg>
  );
};

export default IconOrder;
